module.exports = __webpack_public_path__ + "media/assets/img/flags/ms-MY-7ea8f54462a013b89c865d53ef148675.png";